<template>
  <div class="excluor-button square" @click="toggle" :class="{ 'active': value, 'disabled': disabled }">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ExcluorButton",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit("input", !this.value); // Émet "input" pour mettre à jour v-model
      this.$emit("change", !this.value); // Émet "change" pour les autres actions
    },
  },
};
</script>

<style scoped></style>
